import styled from 'styled-components';
export const ColumnTextRender = styled.text`
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  color: #141e2e;
`;
